'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, TransitionChild } from '@headlessui/react';
import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop';
import { TopNavAccountPanelContent } from '@src/components/TopNavV4/TopNavAccountPanel/TopNavAccountPanelContent';
import { useTopNav } from '@src/components/TopNavV4/TopNavContext';
import { useHeadlessUIReady } from '@src/hooks/useHeadlessUIReady';
import { cn } from '@src/utils/tailwind';
export const TopNavAccountPanel = () => {
  const $ = _c(7);
  const {
    isAccountExpanded,
    setAccountExpanded
  } = useTopNav();
  const isHeadlessUIReady = useHeadlessUIReady();
  const t0 = isAccountExpanded && isHeadlessUIReady;
  let t1;
  if ($[0] !== setAccountExpanded) {
    t1 = () => setAccountExpanded(false);
    $[0] = setAccountExpanded;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ModalBackdrop className="hidden backdrop-blur-sm lg:block" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="fixed inset-0 flex justify-end overflow-y-auto"><TransitionChild><DialogPanel className={cn("size-full max-w-full lg:w-[420px]", "duration-200 ease-out data-closed:translate-x-full")}><TopNavAccountPanelContent /></DialogPanel></TransitionChild></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t0 || $[5] !== t1) {
    t4 = <Dialog transition={true} open={t0} onClose={t1} className="relative z-max transition duration-200 ease-out">{t2}{t3}</Dialog>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};